import { FilterValues } from "../../../data-model/filterValues";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { TableNames } from "../../../enums/tableNames";
import { CallingWorklistView } from "../utils/buildWorklistFilters";
import { CallingWorklistTableState } from "./useCallingWorklistTableData";
import { useFilterAndSearchEffect } from "./useFilterAndSearchEffect";
import {
  PharmaStpFileFilterPayload,
  useFilterPayload,
} from "./useFilterPayload";
import { usePaginationReset } from "./usePaginationReset";
import { useSearchTerm } from "./useSearchTerm";
import { useValidFilters } from "./useValidFilters";

export interface UseFilterAndSearchReturn {
  filterPayload: PharmaStpFileFilterPayload | null;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  paginationResetCount: number;
  validFilters: FilterValues[];
}

export const useFilterAndSearch = (
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
  setPharmaStpFileState: React.Dispatch<
    React.SetStateAction<CallingWorklistTableState>
  >,
  pageSize: number = 120,
  /** When true, filter-driven refetches use the archive list payload. */
  isArchiveView: boolean = false,
  /** Worklist the payload is for; the Pending list also filters on response status. */
  view: CallingWorklistView = CallingWorklistView.NON_EPA,
  /** Table whose filters and search text this list owns. */
  tableName: TableNames = TableNames.CALLING_WORKLIST_ORDERS,
): UseFilterAndSearchReturn => {
  const { searchTerm, setSearchTerm } = useSearchTerm(tableName);

  const { paginationResetCount, setPaginationResetCount } =
    usePaginationReset();

  const validFilters = useValidFilters(tableName);

  const { filterPayload } = useFilterPayload(
    validFilters,
    searchTerm,
    initialDataFetchingExecuted,
    pageSize,
    isArchiveView,
    view,
  );

  useFilterAndSearchEffect(
    filterPayload,
    initialDataFetchingExecuted,
    setTableData,
    setPharmaStpFileState,
    setPaginationResetCount,
  );

  return {
    filterPayload,
    searchTerm,
    setSearchTerm,
    paginationResetCount,
    validFilters,
  };
};
